/**
 * US states and Canadian provinces with their time zones, for working out a
 * stop's zone from its address when no zone is stored.
 * Data from main app: src/utils/mock-data/states.ts (label, code and timezone only)
 */

export interface StateTimezone {
  label: string
  code: string
  timezone: string
}

export const usStates: StateTimezone[] = [
  { label: 'Alabama', code: 'AL', timezone: 'America/Chicago' },
  { label: 'Alaska', code: 'AK', timezone: 'America/Anchorage' },
  { label: 'Arizona', code: 'AZ', timezone: 'America/Phoenix' },
  { label: 'Arkansas', code: 'AR', timezone: 'America/Chicago' },
  { label: 'California', code: 'CA', timezone: 'America/Los_Angeles' },
  { label: 'Colorado', code: 'CO', timezone: 'America/Denver' },
  { label: 'Connecticut', code: 'CT', timezone: 'America/New_York' },
  { label: 'Delaware', code: 'DE', timezone: 'America/New_York' },
  { label: 'Florida', code: 'FL', timezone: 'America/New_York' },
  { label: 'Georgia', code: 'GA', timezone: 'America/New_York' },
  { label: 'Hawaii', code: 'HI', timezone: 'Pacific/Honolulu' },
  { label: 'Idaho', code: 'ID', timezone: 'America/Denver' },
  { label: 'Illinois', code: 'IL', timezone: 'America/Chicago' },
  { label: 'Indiana', code: 'IN', timezone: 'America/Indiana/Indianapolis' },
  { label: 'Iowa', code: 'IA', timezone: 'America/Chicago' },
  { label: 'Kansas', code: 'KS', timezone: 'America/Chicago' },
  { label: 'Kentucky', code: 'KY', timezone: 'America/New_York' },
  { label: 'Louisiana', code: 'LA', timezone: 'America/Chicago' },
  { label: 'Maine', code: 'ME', timezone: 'America/New_York' },
  { label: 'Maryland', code: 'MD', timezone: 'America/New_York' },
  { label: 'Massachusetts', code: 'MA', timezone: 'America/New_York' },
  { label: 'Michigan', code: 'MI', timezone: 'America/Detroit' },
  { label: 'Minnesota', code: 'MN', timezone: 'America/Chicago' },
  { label: 'Mississippi', code: 'MS', timezone: 'America/Chicago' },
  { label: 'Missouri', code: 'MO', timezone: 'America/Chicago' },
  { label: 'Montana', code: 'MT', timezone: 'America/Denver' },
  { label: 'Nebraska', code: 'NE', timezone: 'America/Chicago' },
  { label: 'Nevada', code: 'NV', timezone: 'America/Los_Angeles' },
  { label: 'New Hampshire', code: 'NH', timezone: 'America/New_York' },
  { label: 'New Jersey', code: 'NJ', timezone: 'America/New_York' },
  { label: 'New Mexico', code: 'NM', timezone: 'America/Denver' },
  { label: 'New York', code: 'NY', timezone: 'America/New_York' },
  { label: 'North Carolina', code: 'NC', timezone: 'America/New_York' },
  { label: 'North Dakota', code: 'ND', timezone: 'America/Chicago' },
  { label: 'Ohio', code: 'OH', timezone: 'America/New_York' },
  { label: 'Oklahoma', code: 'OK', timezone: 'America/Chicago' },
  { label: 'Oregon', code: 'OR', timezone: 'America/Los_Angeles' },
  { label: 'Pennsylvania', code: 'PA', timezone: 'America/New_York' },
  { label: 'Rhode Island', code: 'RI', timezone: 'America/New_York' },
  { label: 'South Carolina', code: 'SC', timezone: 'America/New_York' },
  { label: 'South Dakota', code: 'SD', timezone: 'America/Chicago' },
  { label: 'Tennessee', code: 'TN', timezone: 'America/New_York' },
  { label: 'Texas', code: 'TX', timezone: 'America/Chicago' },
  { label: 'Utah', code: 'UT', timezone: 'America/Denver' },
  { label: 'Vermont', code: 'VT', timezone: 'America/New_York' },
  { label: 'Virginia', code: 'VA', timezone: 'America/New_York' },
  { label: 'Washington', code: 'WA', timezone: 'America/Los_Angeles' },
  { label: 'West Virginia', code: 'WV', timezone: 'America/New_York' },
  { label: 'Wisconsin', code: 'WI', timezone: 'America/Chicago' },
  { label: 'Wyoming', code: 'WY', timezone: 'America/Denver' },
  { label: 'District of Columbia', code: 'DC', timezone: 'America/New_York' }
]

export const canadaProvinces: StateTimezone[] = [
  { label: 'Ontario', code: 'ON', timezone: 'America/Toronto' },
  { label: 'Quebec', code: 'QC', timezone: 'America/Toronto' },
  { label: 'British Columbia', code: 'BC', timezone: 'America/Vancouver' },
  { label: 'Alberta', code: 'AB', timezone: 'America/Edmonton' },
  { label: 'Manitoba', code: 'MB', timezone: 'America/Winnipeg' },
  { label: 'Saskatchewan', code: 'SK', timezone: 'America/Regina' },
  { label: 'Nova Scotia', code: 'NS', timezone: 'America/Halifax' },
  { label: 'New Brunswick', code: 'NB', timezone: 'America/Moncton' },
  { label: 'Prince Edward Island', code: 'PE', timezone: 'America/Halifax' },
  {
    label: 'Newfoundland and Labrador',
    code: 'NL',
    timezone: 'America/St_Johns'
  },
  {
    label: 'Northwest Territories',
    code: 'NT',
    timezone: 'America/Yellowknife'
  },
  { label: 'Nunavut', code: 'NU', timezone: 'America/Iqaluit' },
  { label: 'Yukon', code: 'YT', timezone: 'America/Whitehorse' }
]
